import api from "@/modules/api";
import { defineStore } from "pinia";
import { entityStoreFactory } from "./factory/entity-store-factory";
import {
  cursorPagerStoreFactory,
  cursorEncoderById,
} from "./factory/list-store-factory";
import { TextImageModeEnum } from "@/enums/TextImageEnum";

export const useGenerate = defineStore("generate", () => {
  const taskEntityState = entityStoreFactory<TextImage>((e) => e.taskId);
  const {
    updateMap: updateTaskMap,
    getEntity: getTaskEntity,
    map: taskMap,
  } = taskEntityState;

  const {
    dataList: beautifyTaskList,
    initListIfAbsent: initBeautifyTaskListIfAbsent,
    fetchNewerList: fetchNewerBeautifyTaskList,
    fetchOlderList: fetchOlderBeautifyTaskList,
  } = cursorPagerStoreFactory<TextImage>({
    entityStore: taskEntityState,
    fetch: async (cursor) => {
      const response = await api.readTextImagePage({
        cursor,
        sort: { field: "id", order: "desc" },
      });
      updateTaskMap(response.page.data);
      return response.page.data;
    },
    cursorEncoder: cursorEncoderById,
  });

  const createBeautifyTask = async (mediaId: number) => {
    const res = await api.createOneTextImageTask({
      sourceId: mediaId,
      mode: TextImageModeEnum.Beautify,
    });
    updateTaskMap([res.item]);
    return res.item;
  };

  const readTaskByUuid = async (uuid: string) => {
    const res = await api.readTextImageByUuid(uuid);
    updateTaskMap([res.item]);
    return res.item;
  };

  const onTaskFinished = async (taskId: string) => {
    const task = getTaskEntity(taskId);
    if (!task) {
      await initBeautifyTaskListIfAbsent(true);
      return;
    }
    await readTaskByUuid(task.uuid!);
  };

  const deleteTaskByUuid = async (uuid: string) => {
    await api.deleteOneTextImage(uuid);
    await initBeautifyTaskListIfAbsent(true);
  };

  return {
    beautifyTaskList,
    taskMap,
    initBeautifyTaskListIfAbsent,
    fetchNewerBeautifyTaskList,
    fetchOlderBeautifyTaskList,
    createBeautifyTask,
    updateTaskMap,
    getTaskEntity,
    readTaskByUuid,
    onTaskFinished,
    deleteTaskByUuid,
  };
});
